<template>
  <!-- REMINDER - Make sure to replace all the hardcoded vue pages
                  headers with this component. Oh and also give
                  it all the props for text and chevrons.
                  Ultimately -> put this on the route index and remove all
                  imports instances everywhere else. 
 -->
  <div class="fl-sym-bg-primary fl-sym-p-5 fl-sym-text-white fl-sym-relative">
    <div
      class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-left-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pl-4 fl-sym-text-4xl fl-sym-text-white hover:fl-sym-text-opacity-75"
    >
      <img
        @click="backByOneRoute"
        src="@/assets/chevron-left-thin.svg"
        width="15"
        class="fl-sym-cursor-pointer chevron-left-thin"
      />
    </div>
    <img
      @click="goHome"
      src="@/assets/logo.svg"
      width="147"
      class="fl-sym-mx-auto fl-sym-cursor-pointer"
    />
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  computed: {
    ...mapState({
      currentPathName: (state) => state.route.name,
      currentPath: (state) => state.route.path,
    }),
  },
  methods: {
    async backByOneRoute() {
      if (this.isUserInSymptomChecker()) {
        if (!this.isUserOnBeginPage()) {
          if (this.isUserOnSummaryPage()) {
            this.$router.go(-1)
            return
          }
          await this.$store.dispatch("sc/back")
          return
        }
      }
      this.$router.go(-1)
    },
    isUserOnBeginPage() {
      if (this.currentPathName === process.env.VUE_APP_SYMPTOM_CHECKER_BEGIN)
        return true
    },
    isUserInSymptomChecker() {
      if (this.currentPath.includes(process.env.VUE_APP_SYMPTOM_CHECKER_LAYOUT))
        return true
    },
    isUserOnPreSummaryPage() {
      if (this.currentPathName === process.env.VUE_APP_DASHBOARD_PRE_SUMMARY)
        return true
    },
    isUserOnSummaryPage() {
      if (this.currentPathName === process.env.VUE_APP_SYMPTOM_CHECKER_SUMMARY)
        return true
    },
  },
}
</script>
